module.exports = __webpack_public_path__ + "img/shade_btn.117f8977.png";